import styled from "styled-components"

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .text-cont {
        padding: 20px 40px;

        h1 {
            font-size: 78px;
            line-height: 1;
            font-weight: 700;
        }

        p {
            font-size: 14px;
            line-height: calc(22.4 / 14);
            color: rgba(132, 132, 132, 1);
            margin-top: 25px;
        }
    }

    .img-cont {
        width: 100%;
        flex: 1 1;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
`
export default function Cover() {
    return (
        <Wrap>
            <div className="text-cont">
                <h1>
                    AI Skin <br />
                    Analysis Report
                </h1>

                <p>
                    우리의 몸을 감싸며 체내 모든 기관을 보호하는 피부는 몸 상태를 나타내는 지표가 되기도 합니다.
                    <br />
                    그러한 면에서 피부 검진은 여러분의 건강검진을 더욱 더 완성시킬 것입니다.
                    <br />
                    15초만에 피부측정이 완료되며 전송된 데이터를 통해 피부결과를 확인하실 수 있습니다.
                </p>
            </div>

            <div className="img-cont">
                <img src={process.env.PUBLIC_URL + "/image/img_report_cover.png"} />
            </div>
        </Wrap>
    )
}